const az = {
  nav: {
    home: "Ana Səhifə",
    register: "Qeydiyyat",
    login: "Daxil Ol",
    support: "Dəstək",
    pricing: "Tariflər",
  },
  home: {
    hero_badge: "Azərbaycanın Premium Email Platforması",
    hero_title_1: "Emailinizi",
    hero_title_2: "Yeni Səviyyəyə",
    hero_title_3: "Qaldırın",
    hero_subtitle: "Müasir dizayn, güclü təhlükəsizlik, üçdilli dəstək. emailaze ilə email təcrübənizi tamamilə dəyişdirin.",
    hero_cta: "Pulsuz Başla",
    hero_login: "Daxil Ol",
    trust1: "AES-256 Şifrələmə",
    trust2: "99.9% Uptime",
    trust3: "GDPR Uyğun",
    logos_label: "Güvənilən Şirkətlər",
    features_badge: "Niyə emailaze?",
    features_title: "Hər Şey Düşünülmüşdür",
    features_subtitle: "Sizə lazım olan hər xüsusiyyət, istəmədiyiniz hər şeyin olmadığı platforma.",
    feature1_title: "Tam Təhlükəsizlik",
    feature1_desc: "End-to-end AES-256 şifrələmə. Bütün məlumatlarınız tam qorunur, heç bir üçüncü tərəf girişi yoxdur.",
    feature2_title: "İşıq Sürətli Performans",
    feature2_desc: "Bakıdakı yerli serverlər sayəsində ultra-aşağı gecikmə. Emailləriniz anında çatır.",
    feature3_title: "3 Dil Dəstəyi",
    feature3_desc: "Azərbaycan, İngilis və Rus dillərində tam dəstək. Siz seçin, biz uyğunlaşaq.",
    feature4_title: "Ağıllı Filtrasiya",
    feature4_desc: "AI əsaslı spam filtri. 99.8% dəqiqliklə spam aşkarlama, gərəkli emaillər həmişə gəlir.",
    how_badge: "Necə İşləyir",
    how_title: "3 Addımda Başlayın",
    how_subtitle: "Cəmi 5 dəqiqəyə email hesabınızı açın.",
    step1_num: "01",
    step1_title: "Qeydiyyatdan Keçin",
    step1_desc: "Ad, email və şifrənizlə 60 saniyəlik qeydiyyat. Kredit kartı tələb olunmur.",
    step2_num: "02",
    step2_title: "Hesabınızı Qurun",
    step2_desc: "Emailinizi @emailaze.com domeninə bağlayın. Öz domeniniz varsa onu da əlavə edə bilərsiniz.",
    step3_num: "03",
    step3_title: "İstifadəyə Başlayın",
    step3_desc: "Brauzerinizdən, mobil tətbiqimizdən və ya IMAP/SMTP ilə istənilən cihazdan istifadə edin.",
    stats_badge: "Rəqəmlərlə emailaze",
    stats_title: "Minlərlə İstifadəçinin Etibarı",
    stats_desc: "Azərbaycanın ən sürətlə böyüyən email platformasına qoşulun.",
    stat1_num: "50,000+",
    stat1_label: "Aktiv İstifadəçi",
    stat2_num: "99.9%",
    stat2_label: "Server Əlçatanlığı",
    stat3_num: "24/7",
    stat3_label: "Texniki Dəstək",
    stat4_num: "< 50ms",
    stat4_label: "Ortalama Gecikmə",
    reviews_badge: "İstifadəçi Rəyləri",
    reviews_title: "Onlar Artıq Seçib",
    cta_title: "Emailinizi Bu Gün Yüksəldin",
    cta_subtitle: "Pulsuz plan ilə başlayın. Kredit kartı tələb olunmur.",
    cta_btn: "İndi Başla — Pulsuz",
  },
  login: {
    title: "Xoş Gəldiniz",
    subtitle: "emailaze hesabınıza daxil olun",
    email: "Email ünvanı",
    email_placeholder: "ad@emailaze.com",
    password: "Şifrə",
    password_placeholder: "Şifrənizi daxil edin",
    remember: "Məni xatırla",
    forgot: "Şifrəni unutmusunuz?",
    btn: "Daxil Ol",
    or: "və ya",
    no_account: "Hesabınız yoxdur?",
    register_link: "Qeydiyyatdan keçin",
    secure: "SSL şifrələnmiş təhlükəsiz bağlantı",
  },
  register: {
    title: "Hesab Yaradın",
    subtitle: "emailaze ilə emailinizi yeni səviyyəyə qaldırın",
    firstname: "Ad",
    lastname: "Soyad",
    email: "Email ünvanı",
    email_placeholder: "ad.soyad@emailaze.com",
    phone: "Telefon nömrəsi",
    phone_placeholder: "+994 50 000 00 00",
    password: "Şifrə",
    password_placeholder: "Ən az 8 simvol",
    confirm_password: "Şifrənin təkrarı",
    confirm_password_placeholder: "Şifrəni təkrar daxil edin",
    terms: "İstifadə şərtlərini və məxfilik siyasətini qəbul edirəm",
    terms_link: "Şərtlər",
    btn: "Hesab Yarat",
    already: "Artıq hesabınız var?",
    login_link: "Daxil Olun",
    feature1: "Pulsuz plan — kredit kartı tələb olunmur",
    feature2: "AES-256 şifrələmə ilə tam qorunma",
    feature3: "AZ, EN, RU dil dəstəyi",
    feature4: "İstənilən cihazdan giriş",
    error_password: "Şifrələr uyğun gəlmir",
    error_terms: "Şərtləri qəbul etməlisiniz",
    success: "Hesabınız yaradıldı!",
    success_msg: "Email ünvanınıza təsdiq linki göndərildi.",
  },
  pricing: {
    hero_tag: "Şəffaf Qiymətlər",
    hero_title: "Sizə Uyğun Planı Seçin",
    hero_subtitle: "Bütün planlarda AES-256 şifrələmə, 24/7 dəstək və 99.9% uptime daxildir.",
    monthly: "Aylıq",
    annual: "İllik",
    annual_badge: "20% endirim",
    popular: "Ən Populyar",
    plan1_name: "Pulsuz",
    plan1_desc: "Başlamaq üçün ideal",
    plan1_price_monthly: "₼0",
    plan1_price_annual: "₼0",
    plan2_name: "Pro",
    plan2_desc: "Fərdi istifadəçilər və kiçik komandalar üçün",
    plan2_price_monthly: "₼15",
    plan2_price_annual: "₼12",
    plan3_name: "Biznes",
    plan3_desc: "Böyük komandalar və korporasiyalar üçün",
    plan3_price_monthly: "₼49",
    plan3_price_annual: "₼39",
    per_month: "/ay",
    get_started: "Başla",
    contact_sales: "Satışla əlaqə",
    feature_table_title: "Planlar Müqayisəsi",
    feature_table_subtitle: "Hər planın xüsusiyyətlərini müqayisə edin",
    cta_title: "Hələ Qərar Vermədiniz?",
    cta_subtitle: "Komandamız sizə ən uyğun planı seçməkdə kömək edəcək.",
    cta_btn: "Ekspertlə Danış",
  },
  support: {
    hero_title: "Sizə Necə Kömək Edə Bilərik?",
    hero_placeholder: "Sualınızı yazın...",
    channel1_title: "Telefon Dəstəyi",
    channel1_num: "+994 12 000 00 00",
    channel1_hours: "Həftəiçi 09:00 - 18:00",
    channel2_title: "Email Dəstəyi",
    channel2_addr: "support@emailaze.com",
    channel2_time: "24 saat ərzində cavab",
    channel3_title: "Canlı Chat",
    channel3_btn: "İndi Başla",
    channel3_status: "Hazırda aktiv",
    faq_title: "Tez-tez Verilən Suallar",
    faq_subtitle: "Ən çox soruşulan suallara cavablar",
    form_title: "Bizə Yazın",
    form_name: "Ad Soyad",
    form_email: "Email",
    form_subject: "Mövzu",
    form_message: "Mesajınız",
    form_btn: "Göndər",
    form_success: "Mesajınız göndərildi! Tezliklə cavab veriləcək.",
  },
  footer: {
    desc: "emailaze.com — Azərbaycan vətəndaşları üçün müasir, sürətli və təhlükəsiz email hosting platforması.",
    product: "MƏHSUL",
    pricing_link: "Tariflər",
    features: "Xüsusiyyətlər",
    security: "Təhlükəsizlik",
    company: "ŞİRKƏT",
    about: "Haqqımızda",
    blog: "Blog",
    careers: "Karyera",
    help: "DƏSTƏK",
    support_link: "Dəstək Mərkəzi",
    contact: "Əlaqə",
    docs: "Sənədlər",
    legal: "HÜQUQİ",
    terms: "İstifadə Şərtləri",
    privacy: "Məxfilik Siyasəti",
    gdpr: "GDPR",
    copyright: "© 2026 emailaze. Bütün hüquqlar qorunur.",
  },
};

export default az;
